<template>

<!-- <div class="articles-detail article" v-else-if="kb_item_id"> -->
<div class="articles-detail article" v-if="!loading">
    <!-- We're on an article detail -->
    <h1>{{ getKBItem.topic }}</h1>
    <div v-html="getKBItem.content"></div>

    <div class="more-help">
        <div class="two-columns">
            <div class="related-articles" v-if="getKBItem.kb_related_items && getKBItem.kb_related_items.length > 0">
                <h4>Related Articles</h4>
                <ul class="related-article-list">
                    <li v-for="(item, index) in getKBItem.kb_related_items">
                        <router-link :to="'/help-center/articles/' + item.related_item_id">{{ item.topic }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <iframe :src="'https://player.vimeo.com/video/' + getKBItem.video_link" width="640" height="332" frameborder="0" allow="autoplay; fullscreen" allowfullscreen v-if="getKBItem.video_link"></iframe>
    </div>
    <div class="controls">
        <a v-if="!hidePrintButton" :href="'https://s3.us-east-2.amazonaws.com/media.connecteddatasolutions.com/downloads/' + getKBItem.category.dasherize() + '-' + getKBItem.kb_category_id + '-manual.pdf'" target="_blank" class="button action print-button">Print Manual</a>
        <router-link class="button previous" :to="'/help-center/articles/' + this.previous" v-if="previous !== null">Previous</router-link>
        <a class="button previous disabled" v-else>Previous</a>
        <router-link class="button next" :to="'/help-center/articles/' + this.next" v-if="next !== null">Next</router-link>
        <a class="button next disabled" v-else>Next</a>
    </div>
</div>

<loading class="full-page" v-else></loading>

</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
    name: 'articles-detail',
    props: [ 'kb_item_id' ],
    data() {
        return {
            loading: true,
            kbItem: {
                description: '',
                kb_category_id: '',
                parent_item_id: '',
                internal_use_only: 1,
                content: '',
                kb_tags: [],
                related_kb_item_ids: [],
                video_link: ''
            },
            notFound: false,
            hidePrintButton: false
        }
    },
    created() {
		if (window.self != window.top) {
            this.hidePrintButton = true
		}
        this.fetchData()
    },
    watch: {
        kb_item_id(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                this.fetchData()
            }
        }
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getKBItem',
            'getFlatList'
        ]),
        previous() {
            var previous
            for (var i = 0; i < this.getFlatList.length; i++) {
                if (this.kb_item_id == this.getFlatList[i]) {
                    if (i == 0) {
                        previous = null
                        break
                    } else {
                        break
                    }
                } else {
                    previous = this.getFlatList[i]
                }
            }
            return previous
        },
        next() {
            var next
            for (var i = 0; i < this.getFlatList.length; i++) {
                if (this.kb_item_id == this.getFlatList[i]) {
                    if (this.getFlatList[i + 1] == undefined) {
                        next = null
                        break
                    } else {
                        next = this.getFlatList[i + 1]
                        break
                    }
                }
            }
            return next
        }
    },
    methods: {
        ...mapActions('dashboard_module', [
            'updateKBItem'
        ]),
        fetchData() {
            this.loading = true
            this.notFound = false
            var data = {
                kb_item_id: this.kb_item_id
            }
            this.apiCall({ destination: 'get_item_kb_item', data: data }).then(obj => {
                this.loading = false
                if (obj.status == "success") {
                    if (obj.kb_item.internal_use_only) {
                        this.$router.push('/help-center')
                    }
                    this.updateKBItem(obj.kb_item)
                } else {
                    this.notFound = true
                }
            }).catch(err => {
                this.loading = false
                console.log(err);
            })
        }
    }
}
</script>

<style>
h1{
    font-size: 2em;
}
h2 {
    font-size: 1.5em;
    color: #9e0909;
    background-color: #e6e6e6;
}
h3 {
    color: #9e0909;
    font-size: 1.5em;
    text-decoration: underline;
}
h4 {
    background-color: #e6e6e6;
    font-size: 1.25em;
    padding: 0.25em;
}
.more-help {
    border-top: 1px solid #ababab;
}
ul.related-article-list {
    margin-left: 0;
}
</style>
